import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import './LeiLiberdadeEconomica.scss';

class LeiLiberdadeEconomica extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();
	}

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Lei da Liberdade Econômica - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home lei-liberdade-economica-home page-gradient page-gradient--yellow bg-gray" ref="lei-liberdade-economica-home">

          <section className="iniciativas-area lei-liberdade-economica-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink to="/estrategias/para-o-mercado" className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">Lei da Liberdade Econômica</h1>
                        </div>
                        <div className="card__content__body">
                          <p>A Lei 13.874 chegou para simplificar processos e melhorar o ambiente de negócios – nossa participação no processo de elaboração da lei se deu por meio da <DelayLink to="/relacionamentos" className="text_link text_link--yellow">CNF (Confederação Nacional das Instituições Financeiras)</DelayLink>. Conhecida como Lei da Liberdade Econômica, ela criou um marco regulatório para a indústria de fundos ao atender antigos pleitos e avançar em três quesitos:</p>
                          <ul className="bullets bullets--yellow">
                            <li>Aproximar a indústria brasileira dos padrões internacionais;</li>
                            <li>Definir responsabilidades dos agentes;</li>
                            <li>Reduzir custos.</li>
                          </ul>
                          <p>Entenda cada um desses aspectos:</p>
                        </div>
                      </div>
                      {/* <div className="card__image">
                        <img src={images.iniciativas.raio_x.capa} />
                      </div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="iniciativas-body lei-liberdade-economica-body">

            <div className="container container--large">
              <div className="row">
								
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--no-border">
                      <div className="card__content card__content--full">
												
												<div className="row">
													<div className="col-4">
														<img src={images.icons.legal_yellow} />
														<p>
															<strong>Marco legal</strong><br /><br />
															A lei define “fundos de investimento” como condomínios de natureza especial, ou seja, deixa claro que eles não estão sujeitos às regras sobre condomínios do Código Civil. Isso aumenta a segurança jurídica da nossa indústria e a deixa mais próxima dos padrões internacionais.
														</p>
													</div>

													<div className="col-4">
														<img src={images.icons.responsabilidades_yellow} />
														<p>
															<strong>Definição de responsabilidades</strong><br /><br />
															A partir de agora, é “cada um no seu quadrado”. Do lado dos prestadores de serviços, a lei colocou fim à responsabilidade solidária: os deveres de cada agente devem constar no regulamento do fundo – é uma forma de evitar que eles sejam responsabilizados por atividades que não fazem parte do seu escopo de atuação. Os investidores, por sua vez, passam a responder de forma proporcional ao valor das próprias cotas, o que protege a pessoa de ter que fazer um aporte maior que a sua participação no fundo, caso ele fique com patrimônio líquido negativo.
														</p>
													</div>

													<div className="col-4">
														<img src={images.icons.lamp_yellow} />
														<p>
															<strong>Inovação e redução de custos</strong><br /><br />
															Um mesmo fundo pode criar classes diferentes de cotas, cada uma com patrimônio separado das demais. Isso resulta em agilidade e reduz os custos, pois, em vez de criar um fundo para abrigar uma estratégia diferente de investimento, será possível agregar uma nova classe a um que já está em operação. Também acabou a necessidade de registrar o fundo em cartório para obter o CNPJ – basta fazer o registro diretamente na CVM –, o que diminui o gasto para abrir um novo fundo.
														</p>
													</div>
												</div>

											</div>
                    </div>
                  </Fade>
                </div>

              </div>
            </div>

						<div className="container container--large">
							<div className="row">
								
								<div className="col-12">
									<Fade>
										<div className="card card--no-border card--footer">
											<div className="card__content card__content--full">

												<div className="card__content__body" style={{maxWidth: '100%'}}>
													<p style={{maxWidth: '100%'}}>A nova norma também otimizou a Lei das S.A. (6.404), pois determina que não é mais preciso assinar o boletim de subscrição em ofertas públicas que sejam liquidadas na bolsa de valores. </p>
												</div>

											</div>
										</div>
									</Fade>
								</div>

							</div>
						</div>

          </section>

        </div>
      </div>
    );
  }
}

export { LeiLiberdadeEconomica };
